import React from 'react';
import { FaUsers, FaClock, FaBoxOpen, FaShoppingCart, FaArrowDown } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import { HowToPlayPage, GameSection, OverviewIntro, StepList, HowToWinCard, GameModes, CombineModes, CtaCard, FAQAccordion } from '../../../shared/components';
import { colors } from '../../../shared/styles/theme';
import logoSvg from '../../../assets/bibliquien/logo.svg';
import backgroundImg from '../../../assets/bibliquien/bibliquien_background.webp';

const BibliQuienGamePage = () => {
  const t = useTranslation();

  const heroBadges = [
    { label: t('bibliquienGame.badges.physical'), variant: 'secondary' },
    { label: t('bibliquienGame.badges.status'), variant: 'primary' },
  ];

  const heroActions = [
    {
      label: t('bibliquienGame.actions.instructions'),
      href: '#instrucciones',
      variant: 'primary',
      icon: <FaArrowDown />,
    },
    {
      label: t('bibliquienGame.actions.buy'),
      href: '/bibliquien/producto',
      variant: 'outline',
      icon: <FaShoppingCart />,
    },
  ];

  const hero = {
    title: t('bibliquienGame.hero.title'),
    subtitle: t('bibliquienGame.hero.subtitle'),
    badges: heroBadges,
    actions: heroActions,
    image: logoSvg,
    imageAlt: t('bibliquienGame.hero.imageAlt'),
    backgroundImage: backgroundImg,
    background: '#1D3F84',
  };

  const overviewIcons = [<FaUsers />, <FaClock />, <FaBoxOpen />];
  const rawFacts = t('bibliquienGame.overview.facts', { returnObjects: true });
  const overviewFacts = Array.isArray(rawFacts)
    ? rawFacts.map((fact, idx) => ({
        icon: overviewIcons[idx % overviewIcons.length],
        title: fact.title,
        text: fact.text,
      }))
    : [];

  const classicPrepSteps = t('bibliquienGame.classic.preparation.steps', { returnObjects: true }) || [];
  const classicPlaySteps = t('bibliquienGame.classic.howToPlay.steps', { returnObjects: true }) || [];
  const modesItems = t('bibliquienGame.modes.items', { returnObjects: true }) || [];
  const combineExamples = t('bibliquienGame.combine.examples', { returnObjects: true }) || [];
  const faqItems = t('bibliquienGame.faq.items', { returnObjects: true }) || [];

  return (
    <HowToPlayPage hero={hero}>
      {/* De un vistazo */}
      <GameSection
        eyebrow={t('bibliquienGame.overview.eyebrow')}
        title={t('bibliquienGame.overview.title')}
        subtitle={t('bibliquienGame.overview.subtitle')}
      >
        <OverviewIntro items={overviewFacts} />
      </GameSection>

      {/* Modo clásico */}
      <GameSection
        id="instrucciones"
        eyebrow={t('bibliquienGame.classic.eyebrow')}
        title={t('bibliquienGame.classic.title')}
        subtitle={t('bibliquienGame.classic.subtitle')}
        background={colors.neutral.gray50}
      >
        <StepList
          title={t('bibliquienGame.classic.preparation.title')}
          steps={classicPrepSteps}
        />
        <StepList
          title={t('bibliquienGame.classic.howToPlay.title')}
          steps={classicPlaySteps}
        />
        <HowToWinCard
          title={t('bibliquienGame.classic.howToWin.title')}
          success={t('bibliquienGame.classic.howToWin.success')}
          fail={t('bibliquienGame.classic.howToWin.fail')}
          closing={t('bibliquienGame.classic.howToWin.closing')}
        />
      </GameSection>

      {/* Modos adicionales */}
      <GameSection
        eyebrow={t('bibliquienGame.modes.eyebrow')}
        title={t('bibliquienGame.modes.title')}
        subtitle={t('bibliquienGame.modes.subtitle')}
      >
        <GameModes items={modesItems} label={t('bibliquienGame.modes.title')} />
      </GameSection>

      {/* Combiná modos */}
      <GameSection
        eyebrow={t('bibliquienGame.combine.eyebrow')}
        title={t('bibliquienGame.combine.title')}
        subtitle={t('bibliquienGame.combine.subtitle')}
        background={colors.neutral.gray50}
      >
        <CombineModes examples={combineExamples} />
      </GameSection>

      {/* FAQ */}
      <GameSection
        title={t('bibliquienGame.faq.title')}
        subtitle={t('bibliquienGame.faq.subtitle')}
      >
        <FAQAccordion items={Array.isArray(faqItems) ? faqItems : []} />
      </GameSection>

      {/* CTA comercial */}
      <GameSection background={colors.neutral.gray50}>
        <CtaCard
          title={t('bibliquienGame.cta.title')}
          text={t('bibliquienGame.cta.text')}
          buttonText={t('bibliquienGame.cta.buttonText')}
          href="/bibliquien/producto"
        />
      </GameSection>
    </HowToPlayPage>
  );
};

export default BibliQuienGamePage;
